export const HOME_SOLUTIONS = [
  {
    title: 'Managed Transportation',
    icon: '/landing/assets/images/shipsmart/icons/manage.svg',
    image: '/landing/assets/images/shipsmart/ship18.webp',
    description:
      'A single team to plan, source, track and optimize your freight across modes, facilities and markets.',
  },
  {
    title: 'Dedicated Capacity',
    icon: '/landing/assets/images/shipsmart/icons/box2.svg',
    image: '/landing/assets/images/shipsmart/ship4.webp',
    description:
      'Reliable equipment and consistent drivers for repeat lanes, scheduled routes and high-priority freight.',
  },
  {
    title: 'Freight Brokerage',
    icon: '/landing/assets/images/shipsmart/icons/gear.svg',
    image: '/landing/assets/images/shipsmart/ship6.webp',
    description:
      'Responsive access to vetted capacity for everyday loads, surges and challenging markets.',
  },
  {
    title: 'Warehousing & Distribution',
    icon: '/landing/assets/images/shipsmart/icons/warehouse.svg',
    image: '/landing/assets/images/shipsmart/ship7.webp',
    description:
      'Connected storage, fulfillment and distribution capacity integrated with your transportation network.',
  },
  {
    title: 'Expedited & Specialized',
    icon: '/landing/assets/images/shipsmart/icons/flash.svg',
    image: '/landing/assets/images/shipsmart/ship8.webp',
    description:
      'Fast, hands-on support for time-critical, oversized, open-deck and project-driven freight.',
  },
] as const;
